import AbusingInfo from './AbusingInfo';

export default AbusingInfo;
